
import { Middleware } from 'redux'
import { vCallIncomingMessageReceived, vCallSetAvailable, vCallSocketClosed, vCallSocketOpened } from './videoSlice';
import { setPingValue, setAvailable } from '../userState/userStateSlice';
import { IVCallIncomingMessage } from './types';
import { uid } from '@ht/shared/methods';

const vCallMiddleware: Middleware = store => {
    let ws: WebSocket;
    let avail = true;
    let tries = 1
    let wait = false;
    const maxtry = 3
    let intervalId = 0
    let lastPing = Date.now()

    const ping = () => {
        if (ws.readyState === 1 && avail) {
            lastPing = Date.now()
            ws.send(JSON.stringify({ requesttype: "Ping", SubscriptionId: process.env.REACT_APP_SUBSCRIPTIONID }))
        } else {
            ws.close()
        }
    }
    const onOpen = () => {
        store.dispatch(vCallSocketOpened());
        store.dispatch(vCallSetAvailable(true));
        avail = true
        tries = 1
        wait = false;
        console.log("connected to video core service")
        ping();
    }
    const onMessage = (event: any) => {
        const msg = event.data;
        if (msg === "Pong") {
            store.dispatch(setPingValue(Date.now() - lastPing));
            setTimeout(() => {
                ping()
            }, 1000)
        }

        if (msg.includes("User with id") && msg.includes("connected"))
            store.dispatch(vCallSocketOpened());
        if (msg.includes('"ReceiveCall"')) {
            const incoming = JSON.parse(msg) as IVCallIncomingMessage;
            incoming.roomId = `${incoming.username}_${incoming.deviceid}`
            store.dispatch(vCallIncomingMessageReceived(incoming));
        }
        else if (msg.includes('"streamId"')) {

            const incoming = JSON.parse(msg) as IVCallIncomingMessage;
            store.dispatch(vCallIncomingMessageReceived(incoming));
        }
    }
    const onClose = () => {
        store.dispatch(vCallSocketClosed());
        store.dispatch(vCallSetAvailable(false));
        console.log("disconnecting from server")
        wait = false
    }
    const initConnection = (domain: string, username: string) => {
        clearInterval(intervalId)
        if (ws === undefined || ws.readyState !== 1) {
            const deviceidChanging = uid(21)
            console.log(`connecting to ${domain}${deviceidChanging}/agent/${username}`)
            ws = new WebSocket(`${domain}${deviceidChanging}/agent/${username}`);
            wait = true;
            ws.onopen = () => {
                onOpen();
            };

            ws.onmessage = (event) => {
                onMessage(event)

            };
            ws.onclose = () => {
                onClose()
            }
            ws.onerror = () => {
                wait = false
                store.dispatch(vCallSocketClosed());
            }
        }
    }
    const checkTimer = (domain: string, username: string) => {
        if (!avail)
            ws.close();
        if (Date.now() - lastPing > 6000)
            ws.close();
        if (avail)
            if (ws.readyState !== 1 && !wait) {
                tries++
                if (avail && tries <= maxtry)
                    initConnection(domain, username);
                else if (avail && tries > maxtry)
                    store.dispatch(setAvailable(false))
            } else {
                tries = 0
            }
    }
    const startConnecting = () => {
        const { user } = store.getState().auth;
        const domain = process.env.REACT_APP_VIDEO_WS_ADDRESS ?? "";
        const username = user?.username;
        const deviceId = user?.deviceId;
        if (deviceId) {
            initConnection(domain, username)

            const timer = window.setInterval(() => {
                checkTimer(domain, username)

            }, 2000)
            intervalId = timer

        }
    }
    return next => action => {

        const isConnectionEstablished = ws && ws.readyState == 1 && store.getState().vcall.vCallStatus && store.getState().vcall.vCallStatus === "connected";
        const actionString = action.type.toString().split('/')[1]
        switch (actionString) {
            case "vCallWSStartConnecting":
                startConnecting();
                break;
            case "vCallWSDisconnect":
                ws.close();
                break;
            case "setAvailable":
                avail = action.payload
                tries = 0
                break;
            case "vCallSendMessage":
                if (isConnectionEstablished) {
                    try {
                        ws.send(action.payload.content);
                    } catch (e) {
                        console.log("ERROR", e)
                    }
                }
                break;

        }



        next(action);
    }
}

export default vCallMiddleware;